import './scripts/modernizr';
import initAnimations from './scripts/animations';
import header from './scripts/header';
import footer from './scripts/footer';
import replaceIcons from './scripts/icons';
import wordpressUI from './scripts/wordpressUI';
import wordpressBlocks from './scripts/wordpressBlocks';
import forms from './scripts/forms';

import accordions from './template-parts/blocks/accordions/accordions';
import articles from './template-parts/blocks/articles/articles';
import cards from './template-parts/blocks/cards/cards';
import hero from './template-parts/blocks/hero/hero';
import statistics from './template-parts/blocks/statistics/statistics';
import mediaBanner from './template-parts/blocks/media-banner/media-banner';
import showcaseCards from './template-parts/blocks/showcase-cards/showcase-cards';

export const docReady: (fn: () => void) => void = (fn) => {
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

// Check if we're in the block editor (post.php or post-new.php)
const isBlockEditor = window.location.href.includes('post.php') || window.location.href.includes('post-new.php');

if (isBlockEditor) {
  // Initialize WordPress UI customizations for the block editor
  wordpressUI();
} else {
  docReady(() => {
    [
      initAnimations,
      header,
      footer,
      replaceIcons,
      wordpressBlocks,
      accordions,
      articles,
      cards,
      hero,
      statistics,
      mediaBanner,
      showcaseCards,
      forms,
    ].forEach((fn) => {
      try {
        fn();
      } catch (e) {
        console.error(e);
      }
    });
  });
}
